<template>
  <VTable
    class="sales-revenue-manager"
    :items="computedItems"
    :checked-rows="checkedRows"
    :fields="fields"
    :loading="loading"
    :on-input-search="onInputSearch"
    searchPlaceholder="Search for car...."
    hideAddButton
    hideCheckHeader
    hover
    striped
    border
    small
    fixed
    dark
  >
    <template #header-data>
      <div class="sales-revenue-manager-total-revenue">
        Total revenue: {{totalRevenue}}
      </div>
    </template>
    <template #footer>
      <VPagination :items-count="itemsCount"  class="user-manager-card__footer-pagination"/>
    </template>
  </VTable>
</template>
<script>
import {
  createSalesRevenueManagerMixin,
  salesRevenueManagerStore
} from "@/mixins/salesRevenueManagerMixin";
import { debounce } from "@/utils/debounce";
import convertNumberToCurrency from '@/utils/convertNumberToCurrency'

const defaultImage = 'https://media.carsandbids.com/cdn-cgi/image/width=712,height=468,quality=70/da4b9237bacccdf19c0760cab7aec4a8359010b0/photos/3ja0R3IXGI2-2.lmFYrFQis.jpg?t=160323755351'

export default {
  name: 'VSalesRevenueTable',

  mixins: [createSalesRevenueManagerMixin()],

  components: {
  },

  data: () => {
    return {
      loading: false,
      lastSearchTerm: null,
      searchFn: () => {},
      checkedRows: []
    }
  },

  computed: {
    fields() {
      return [
        { key: "rowId", label: "" },
        {
          key: "carListing",
          label: "Car",
          _style: "min-width: 275px",
          _classes: "car"
        },
        {
          key: "seller",
          label: "Seller",
          _style: "min-width: 125px",
          _classes: "username"
        },
        {
          key: "buyer",
          label: "Buyer",
          _style: "min-width: 125px",
          _classes: "username"
        },
        {
          key: "auctionKind",
          label: "Auction Kind",
          _style: "min-width: 100px",
          _classes: "auction-kind"
        },
        {
          key: "lastBid",
          label: "Last Bid",
          _style: "min-width: 100px;",
          _classes: "last-bid"
        },
        {
          key: "totalRevenue",
          label: "Total Revenue",
          _style: "min-width: 100px",
          _classes: "total-revenue"
        }
      ]
    },
    items() {
      return this[salesRevenueManagerStore.getterTypes.GETTER_AUCTIONS]
    },
    itemsCount() {
      return this[salesRevenueManagerStore.getterTypes.GETTER_AUCTIONS_COUNT]
    },
    computedItems() {
      return this.items && this.items.map(a => {
        return {
          ...a,
          id: a.car_id,
          seller: a.seller_username || '',
          buyer: a.buyer_username || '',
          car: {
            id: a.car_id,
            title: a.car_title,
            make: a.car_make,
            model: a.car_model,
            createdAt: a.car_created_at,
            startDate: a.car_start_date,
            endDate: a.car_end_date,
            imageUrl: a.image_car_url || defaultImage,
            showInfo: true,
            showEndDate: true,
            hideLink: true,
            format: 'DD.MM.YY hh:mm',
          },
          auctionKind: a.car_reserve ? 'reserve' : 'no reserve',
          lastBid: this.getLastBid(a),
          totalRevenue: convertNumberToCurrency(Number(a.total_revenue))
        }
      })
    },
    totalRevenue() {
      return convertNumberToCurrency(this[salesRevenueManagerStore.getterTypes.GETTER_TOTAL_REVENUE])
    }
  },

  watch: {
    computedItems() {
      this.$nextTick(() => {
        this.checkRows()
      })
    },
    $route () {
      this.loadData()
    }
  },

  async created() {
    this[salesRevenueManagerStore.actionTypes.ACTION_JOIN_TO_SALES_REVENUE_MANAGER]();
    await this.loadData();

    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        };

        if (!query.search && query.skip) {
          query.skip = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => {});
      },
      200
    );
  },

  methods: {
    getBidAndType(auction) {
      return {
        bid: auction.max_bid ? auction.max_bid : 0,
        type: auction.car_reserve ? 'reserve' : 'no reserve'
      }
    },
    isSuccessfull(auction) {
      const { bid, type } = this.getBidAndType(auction)
      return (type === 'reserve' && bid >= auction.car_reserve_value) 
        || (type === 'no reserve' && bid !== 0)
    },
    getLastBid (auction) {
      const { bid, type } = this.getBidAndType(auction)

      if (type === 'reserve' && bid < auction.car_reserve_value) {
        return {
          bid: convertNumberToCurrency(bid),
          info: 'The auction bid didn’t meet the reserved price.'
        }
      }

      return { bid: convertNumberToCurrency(bid) }
    },
    checkRows() {
      this.checkedRows = []
      this.computedItems.forEach(item => {
        if (this.isSuccessfull(item)) return
        
        this.checkedRows.push(item)
      })
    },
    onInputSearch(t) {
      this.searchFn(t);
    },
    async loadData() {
      this.loading = true;
      await this[salesRevenueManagerStore.actionTypes.ACTION_LOAD_AUCTIONS]({
        take: this.$route.query.take || 10,
        skip: this.$route.query.skip || 0,
        search: this.$route.query.search,
        all: true
      });
      this.loading = false;
      this.checkRows()
    }
  }
};
</script>
